import React from "react";
import { useParams } from "react-router";

//Material UI
import Box from "@material-ui/core/Box";

//Custom components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import PosebnaPonudaForm from "./PosebnaPonudaForm";

const PrijevozniciPosebnaPonudaPage = React.memo((props) => {
  const { id } = useParams();

  const recordId = parseInt(id, 10);

  return (
    <PrijevozniciPage>
      <Box m={2}>
        <PosebnaPonudaForm id={recordId}/>
      </Box>
    </PrijevozniciPage>
  );
})

export default PrijevozniciPosebnaPonudaPage;
